export class AzureSubscription {
    asms_no: string;
    name_suffix: string;
    environment: string;
    tenant_id: string;
    management_group_id: string;
    budget: string;
    github_repos: GitHubRepos;

    constructor (json: any) {
        this.asms_no = json.asms_no;
        this.name_suffix = json.name_suffix;
        this.environment = json.environment;
        this.tenant_id = json.tenant_id;
        this.management_group_id = json.management_group_id;
        this.budget = json.budget;
        this.github_repos = json.github_repos;
    }

}

export interface GitHubRepo {
    repo: string;
}

export interface GitHubRepos {
    github_repos: GitHubRepo[];
}

export interface AzEnvironment {
    id: string;
    name: string;
}

export interface AzTenant {
    id: string;
    name: string;
}

export interface AzManagementGroup {
    id: string;
    name:string;
    tenants: AzTenant[];
}